import { render, staticRenderFns } from "./Form9CaseInformation.vue?vue&type=template&id=0976ecc5&scoped=true"
import script from "./Form9CaseInformation.vue?vue&type=script&lang=ts"
export * from "./Form9CaseInformation.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0976ecc5",
  null
  
)

export default component.exports